
import { controls } from "../../controls";


const rp962 = {
  label: "BORROWING LOAN REPAYMENT  ",
  pageLabel: "BORROWING LOAN REPAYMENT ",
  starting: true,
  url: "rp962",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [ 
    
    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),    

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "BORROWING LOAN REPAYMENT REPORT ",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },


    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "sr_no",
        width: 40,
        rwidth:"*"

      },
      {
        Header: "Account Number",
        accessor: "AcctCode",
        width: 80,
        rwidth:"*"
      },
      {
        Header: "Account Name",
        accessor: "Acctname",
        width: 250,
        rwidth: 150
      },
      {
        Header: "Int Rate",
        accessor: "IntRate",
        rwidth:"*"
      },
      {
        Header: "Drawing Date",
        accessor: "LoanDate",
        rwidth:"*"
      },
      {
        Header: "Drawl Amount",
        accessor: "sanctionamt",
        rwidth:"*"
      },
      {
        Header: "Repayment Date As Per Loan Limit Letter",
        accessor: "Loanrepaymentdate",
        rwidth:"*"
      },
      {
        Header: "Loan Repayment Amount",
        accessor: "Installment",
        rwidth:"*"
      },
      {
        Header: "Repayment Date ",
        accessor: "repaymentdate",
        rwidth:"*"
      },
      {
        Header: "Sign ",
        accessor: "sign",
        rwidth:"*"
      }
    ]
  }
};

export default rp962;